<template>
  <div class="downloaddetail-container">
    <div class="downloaddetail-content dib tl">
      <el-breadcrumb class="content-breadcrumb" separator=" > ">
        <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
        <el-breadcrumb-item><a href="/dataDownload">资料下载</a></el-breadcrumb-item>
        <el-breadcrumb-item>{{breadcrumb}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content-divider"></div>
      <div class="downloaddetail-section1 dib">
        <div class="section1-leftlist dib">
          <div class="selectlist-container">
            <div class="selectlist-header tc">资料下载</div>
            <div class="selectlist-cell tl" :value="item.id"
                 :class="(item.id === listValue)? 'is-active': ''"
                 @click="clickCell(item.id)"
                 v-for="item in downloadList">{{item.name}}</div>
          </div>
          <div class="recommendDownload-container tc">
            <div class="recommendDownload-header">推荐下载</div>
            <div class="recommendDownload-divider"></div>
            <ul class="recommendDownload-list tl">
              <li v-for="(item, index) in recommendList" @click="clickRecommend(index)"
                  class="recommendDownload-item">{{item.title}}</li>
            </ul>
            <div class="recommendDownload-divider"></div>
            <img class="recommendDownload-wechat"
                 src="../../assets/img/dataDownload/downloadDetail/wechat.png" alt="关注微信公众号" />
            <div class="recommendDownload-misc">关注微信公众号</div>
          </div>
        </div>
        <div class="section1-rightcontent dib">
          <div class="title-image tc" :style="{'backgroundImage':  'url(' + imageSrc + ')'}">
            <div class="title-mask">
              <h1 class="misc">{{contentTitle}}</h1>
              <el-button class="download-button"  @click="dialogOpen" round>立即下载</el-button>
            </div>
          </div>
          <div class="content-main" v-html="contentData"></div>
        </div>
        <div class="section1-footer tc">
          <el-button class="download-button" @click="dialogOpen" round>立即下载</el-button>
        </div>
      </div>
      <download-panel ref="downloadPanel"></download-panel>
    </div>
  </div>
</template>
<script>
import DownloadPanel from '../common/downloadPanel.vue'
export default {
  name: 'dataDownloadDetail',
  metaInfo () {
    return {
      title: '资料采购下载_' + this.contentTitle + '_甄云官网', // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: ''
      },
      {
        name: 'description',
        content: this.$seo.datadownload.description
      }]
    }
  },
  components: {
    DownloadPanel
  },
  data () {
    return {
      downloadList: [],
      recommendList: [],
      breadcrumb: '',
      listValue: '1',
      itemValue: '1',
      dialogVisible: false,
      imageSrc: this.$global.globalPath + this.$store.state.downloadDetailData.img,
      contentTitle: this.$store.state.downloadDetailData.title,
      contentData: this.$store.state.downloadDetailData.content || '',
      filePath: this.$global.globalPath + this.$store.state.downloadDetailData.path || ''
    }
  },
  created () {
    this.listValue = this.$route.query.list || '1'
    this.itemValue = this.$route.query.item || '1'
    this.getCatalogue()
    if (this.contentData === '') {
      this.getContent()
    }
    this.getRecommendList()
  },
  methods: {
    clickCell (num) {
      this.listValue = num
      this.$router.push({
        name: 'DataDownload',
        query: {
          list: this.listValue
        }
      })
    },
    clickRecommend (index) {
      let routeUrl = this.$router.resolve({
        name: 'DataDownloadDetail',
        query: {
          list: this.recommendList[index].list || 1, // 提醒：得问后端要list数据
          item: this.recommendList[index].id
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    getCatalogue (callback) {
      this.$api.post('/document/catalogue', {}, (r) => {
        if (r.code === 0) {
          this.downloadList = r.data
          this.breadcrumb = this.downloadList.find((item) => {
            return item.id === this.listValue
          }).name
          if (callback) {
            callback(r.data)
          }
        } else {
          this.$message.error(r.message)
        }
      })
    },
    getContent (callback) {
      this.$api.post('/document/content_detail', { id: this.itemValue }, (r) => {
        if (r.code === 0) {
          this.contentData = r.data.content
          this.contentTitle = r.data.title
          this.imageSrc = this.$global.globalPath + r.data.img
          this.filePath = this.$global.globalPath + r.data.path
          if (callback) {
            callback(r.data)
          }
        } else {
          this.$message.error(r.message)
        }
      })
    },
    getRecommendList () {
      this.$api.post('/document/recommend', {}, (r) => {
        if (r.code === 0) {
          this.recommendList = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    dialogOpen () {
      this.$api.post('/document/twenty_four_hour', {}, (r) => {
        if (r.code === 0) {
          if (r.data === 1) {
            this.$refs.downloadPanel.openDialog(true)
            let postform = {
              postemail: r.info.email,
              postname: r.info.name,
              postid: this.itemValue
            }
            this.$refs.downloadPanel.sendEmail(postform)
          } else {
            this.$refs.downloadPanel.openDialog(false)
          }
        } else {
          this.$message.error(r.message)
        }
      })
    }
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/dataDownloadDetail.scss";
</style>



// WEBPACK FOOTER //
// dataDownloadDetail.vue?dd489072